export const DEVICE_TYPE_COLORS: Record<string, string> = {
  kiosk: '#3182ce',
  reader: '#38a169',
  printer: '#805ad5',
  display: '#dd6b20',
  default: '#718096',
};

export const DEVICE_TYPE_BADGE_COLORS: Record<string, string> = {
  kiosk: 'blue',
  reader: 'green',
  printer: 'purple',
  display: 'orange',
  default: 'default',
};

export const ASSIGNMENT_COLORS = {
  ASSIGNED: '#38a169',
  UNASSIGNED: '#e53e3e',
} as const;

export const MESSAGES = {
  DEVICE_CREATED: 'Device created successfully.',
  DEVICE_UPDATED: 'Device updated successfully.',
  DEVICE_DELETED: 'Device deleted successfully.',
  DEVICE_ASSIGNED: 'Device assigned to store successfully.',
  DEVICE_UNASSIGNED: 'Device unassigned from store successfully.',
  ERROR_CREATE: 'Failed to create device.',
  ERROR_UPDATE: 'Failed to update device.',
  ERROR_DELETE: 'Failed to delete device.',
  ERROR_ASSIGN: 'Failed to assign device.',
  ERROR_FETCH: 'Failed to fetch devices.',
  UNSAVED_CHANGES: 'You have unsaved changes. Are you sure you want to cancel?',
  NO_DEVICES_FOUND: 'No devices found',
  ADJUST_SEARCH: 'Try adjusting your search or filter criteria',
  ADD_FIRST_DEVICE: 'Get started by adding your first device',
  CONFIRM_DELETE: 'Are you sure you want to delete this device?',
} as const;

export const VALIDATION_MESSAGES = {
  NAME_REQUIRED: 'Device name is required',
  IDENTIFIER_REQUIRED: 'Device identifier is required',
  TYPE_REQUIRED: 'Device type is required',
} as const;

export const PLACEHOLDERS = {
  SEARCH: 'Search devices or stores...',
  FILTER_TYPE: 'Filter by type',
  SELECT_TYPE: 'Select device type',
  SELECT_MERCHANT: 'Select merchant',
  SELECT_STORE: 'Select store',
  DEVICE_NAME: 'Enter device name',
  DEVICE_IDENTIFIER: 'Enter device identifier',
} as const;

export const LABELS = {
  PAGE_TITLE: 'Device Assignment',
  PAGE_SUBTITLE: 'Manage and assign devices to your stores',
  ADD_DEVICE: 'Add Device',
  EDIT_DEVICE: 'Edit Device',
  DELETE_DEVICE: 'Delete Device',
  NAME: 'Device Name',
  IDENTIFIER: 'Device Identifier',
  DEVICE_TYPE: 'Device Type',
  MERCHANT: 'Merchant',
  STORE: 'Store',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  SAVING: 'Saving...',
  UNSAVED_CHANGES: 'Unsaved Changes',
  YES: 'Yes',
  NO: 'No',
  ASSIGNED: 'Assigned',
  UNASSIGNED: 'Unassigned',
  TOTAL_DEVICES: 'Total Devices',
  UNASSIGNED_DEVICES: 'Unassigned Devices',
} as const;

export const STORE_UNASSIGNED_ID = 'unassigned';
export const STORE_UNASSIGNED_NAME = 'Unassigned Devices';
export const DEFAULT_MERCHANT_NAME = 'Unknown Merchant';
